<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="fmh"><span class="epub-b">CONTENTS</span></p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc-bot"><span href="#/xhtml/dedication#ded" title="Link target outside of Sample">Dedication</span></p>
<p class="toc"><a href="#/xhtml/part1#pt1">Part One</a></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1">Chapter 1</a></p>
<p class="toc"><a href="#/xhtml/chapter2#ch2">Chapter 2</a></p>
<p class="toc"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">Chapter 3</span></p>
<p class="toc-pt"><span href="#/xhtml/part2#pt2" title="Link target outside of Sample">Part Two</span></p>
<p class="toc"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Chapter 4</span></p>
<p class="toc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc-pt"><span href="#/xhtml/part3#pt3" title="Link target outside of Sample">Part Three</span></p>
<p class="toc"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">Chapter 8</span></p>
<p class="toc"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Chapter 9</span></p>
<p class="toc-pt"><span href="#/xhtml/part4#pt4" title="Link target outside of Sample">Part Four</span></p>
<p class="toc"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Chapter 10</span></p>
<p class="toc"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Chapter 11</span></p>
<p class="toc"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Chapter 12</span></p>
<p class="toc-pt"><span href="#/xhtml/part5#pt5" title="Link target outside of Sample">Part Five</span></p>
<p class="toc"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Chapter 13</span></p>
<p class="toc"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">Chapter 14</span></p>
<p class="toc-bot"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Chapter 15</span></p>
<p class="toc"><span href="#/xhtml/adcard#adc" title="Link target outside of Sample">Also by Alan Glynn</span></p>
<p class="toc"><span href="#/xhtml/abouttheauthor#ata" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/xhtml/copyright#crt" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2fec57aa